import Vue from 'vue'
import Router from 'vue-router'
import ControlPanel from '@/components/ControlPanel'
import ConnectionPanel from '@/components/ConnectionPanel'
import Login from '@/components/Login'
import Patients from '@/components/Patients'
import Ordinations from '@/components/Ordinations'
import WorkOrders from '@/components/WorkOrders'
import WorkOrder from '@/components/WorkOrder'
import DentalSolutions from '@/components/DentalSolutions'
import DentalSolution from '@/components/DentalSolution'
import PrintDsDaily from '@/components/PrintDsDaily'
import PrintDsMonthly from '@/components/PrintDsMonthly'
import PrintDsClient from '@/components/PrintDsClient'
import ReportDsHolder from '@/components/ReportDsHolder'
import PrintWorkOrder from '@/components/PrintWorkOrder'
import Protetics from '@/components/Protetics'
import Employees from '@/components/Employees'
import Reports from '@/components/Reports'
import ReportsDsDaily from '@/components/ReportsDsDaily'
import ReportsDsMonthly from '@/components/ReportsDsMonthly'
import ReportsDsClient from '@/components/ReportsDsClient'
import Profile from '@/components/Profile'
import Tasks from '@/components/Tasks'
import ProfileChat from '@/components/ProfileChat'
import ProfileUser from '@/components/ProfileUser'
import Notifications from '@/components/Notifications'

Vue.use(Router)

export default new Router(
{
    routes: [
    {
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
        path: '/login/:verifyCode',
        name: 'Login',
        component: Login
    },
    {
        path: '/controlpanel/basic',
        name: 'ControlPanel',
        component: ControlPanel
    },
    {
        path: '/controlpanel/connection',
        name: 'ConnectionPanel',
        component: ConnectionPanel
    },
    {
        path: '/patients',
        name: 'Patients',
        component: Patients
    },
    {
        path: '/patients/:patientId',
        name: 'WorkOrders',
        component: WorkOrders
    },
    {
        path: '/ordinationsandlabs',
        name: 'Ordinationsandlabs',
        component: Ordinations
    },
    {
        path: '/workorders/:workOrderId',
        name: 'WorkOrder',
        component: WorkOrder
    },
    {
        path: '/printworkorder/:workOrderId',
        name: 'PrintWorkOrder',
        component: PrintWorkOrder
    },
    {
        path: '/protetics',
        name: 'Protetics',
        component: Protetics
    },
    {
        path: '/employees',
        name: 'Employees',
        component: Employees
    },
    {
        path: '/reports',
        name: 'Reports',
        component: Reports
    },
    {
        path: '/dentalsolutions',
        name: 'DentalSolutions',
        component: DentalSolutions
    },
    {
        path: '/dentalsolutions/:dentalSolutionId',
        name: 'DentalSolution',
        component: DentalSolution
    },
    {
        path: '/profile',
        name: 'Profile',
        component: Profile,
        children: [
        {
            path: 'tasks',
            name: 'Tasks',
            component: Tasks
        },
        {
            path: 'chat',
            name: 'Chat',
            component: ProfileChat
        },
        {
            path: 'notifications',
            name: 'Notifications',
            component: Notifications
        },
        {
            path: 'user',
            name: 'User',
            component: ProfileUser
        }]
    },
    {
        path: '/printdsdailyreport',
        name: 'PrintDsDaily',
        component: PrintDsDaily,
    },
    {
        path: '/printdsmonthlyreport',
        name: 'PrintDsMonthly',
        component: PrintDsMonthly,
    },
    {
        path: '/printdsclientreport',
        name: 'PrintDsClient',
        component: PrintDsClient,
    },
    {
        path: '/reportsds',
        name: 'ReportsDs',
        component: ReportDsHolder,
        children: [
        {
            path: 'daily',
            name: 'ReportsDsDaily',
            component: ReportsDsDaily
        },
        {
            path: 'monthly',
            name: 'ReportsDsMonthly',
            component: ReportsDsMonthly
        },
        {
            path: 'client',
            name: 'ReportsDsClient',
            component: ReportsDsClient
        }]
    }]
})


// WEBPACK FOOTER //
// ./src/router/index.js